module.exports = __webpack_public_path__ + "static/media/management_key_white.1be7129b.svg";